import styled, { keyframes } from "styled-components";

const rotation = keyframes`
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
`;

export default styled.div`
  animation: ${rotation} 2s infinite linear;
`;
